function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { sync } from 'vuex-pathify';
import template from './susvimo-product-details.html';

var SusvimoProductDetails = /*#__PURE__*/function () {
  function SusvimoProductDetails() {
    _classCallCheck(this, SusvimoProductDetails);
  }

  _createClass(SusvimoProductDetails, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-susvimo-product-details', {
        template: template,
        props: {
          variants: {
            type: Array,
            "default": function _default() {}
          },
          selectedProcedure: {
            type: String,
            "default": ''
          },
          labels: {
            type: Object,
            "default": function _default() {}
          },
          rules: {
            type: Object
          },
          countries: {
            type: Array,
            "default": function _default() {
              return [];
            }
          }
        },
        computed: {
          form: sync('forms/form'),
          productDetails: function productDetails() {
            var _this = this;

            return this.variants.find(function (variant) {
              return variant.procedure === _this.selectedProcedure.trim();
            }).items;
          }
        }
      });
    }
  }]);

  return SusvimoProductDetails;
}();

export default SusvimoProductDetails;